import type { ComponentEntry } from '../../core/common-types'

const entry: ComponentEntry = {
	componentType: 'TPAWidget',
	loadComponent: () => {
		return import('../TpaCommon/TPABaseComponent.js' /* webpackChunkName: "TPABaseComponent" */)
	},
}

export default entry
